import { useDeployWatcher } from '@skupreme/shared/deploy';
import { ToastRegion } from '@skupreme/shared/ui';
import { useLocation } from 'react-router-dom';

/* Pages a new deploy may reload out from under the user: the signed-out screens. */
const RELOAD_SAFE_PATHS = [
  '/',
  '/login',
  '/register',
  '/forgot-password',
  '/request-password',
  '/accept-invite',
];

/** Brings an open tab onto a new deploy (EN-3481). Mount once, inside the router. */
export function DeployWatcher() {
  const { pathname } = useLocation();

  useDeployWatcher({
    currentVersion: import.meta.env.VITE_APP_VERSION,
    pathname,
    reloadSafePaths: RELOAD_SAFE_PATHS,
  });

  return <ToastRegion />;
}
